export const CONVEX_URL = process.env.PUBLIC_CONVEX_URL;

if (!CONVEX_URL) {
  throw new Error("Missing PUBLIC_CONVEX_URL (must be set for client bundle)");
}
